import type { PendingSymbolIndexTask } from './task-queue-types.js';

function higherPriority(a: PendingSymbolIndexTask, b: PendingSymbolIndexTask): boolean {
  return a.priority > b.priority;
}

export class SymbolIndexTaskPriorityHeap {
  private readonly heap: PendingSymbolIndexTask[] = [];

  clear(): void {
    this.heap.length = 0;
  }

  push(task: PendingSymbolIndexTask): void {
    this.heap.push(task);
    let i = this.heap.length - 1;
    while (i > 0) {
      const parent = Math.floor((i - 1) / 2);
      if (!higherPriority(this.heap[i]!, this.heap[parent]!)) break;
      this.swap(i, parent);
      i = parent;
    }
  }

  pop(): PendingSymbolIndexTask | undefined {
    if (this.heap.length === 0) return undefined;
    const top = this.heap[0]!;
    const last = this.heap.pop()!;
    if (this.heap.length > 0) {
      this.heap[0] = last;
      this.sink(0);
    }
    return top;
  }

  get size(): number {
    return this.heap.length;
  }

  private sink(start: number): void {
    let i = start;
    while (true) {
      const left = i * 2 + 1;
      const right = left + 1;
      let best = i;
      if (left < this.heap.length && higherPriority(this.heap[left]!, this.heap[best]!)) best = left;
      if (right < this.heap.length && higherPriority(this.heap[right]!, this.heap[best]!)) best = right;
      if (best === i) break;
      this.swap(i, best);
      i = best;
    }
  }

  private swap(i: number, j: number): void {
    const tmp = this.heap[i]!;
    this.heap[i] = this.heap[j]!;
    this.heap[j] = tmp;
  }
}
